var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6539 3.65072C13.8319 3.8216 13.8376 4.10442 13.6668 4.28241L10.6645 7.40977C10.5802 7.49753 10.4638 7.54714 10.3422 7.54714C10.2205 7.54714 10.1041 7.49753 10.0199 7.40977L8.19771 5.51166L6.03836 7.76099L7.57682 9.23791L2.62207 10.6745L3.85532 5.66527L5.39378 7.14219L7.87542 4.55714C7.95967 4.46939 8.07606 4.41978 8.19771 4.41978C8.31936 4.41978 8.43576 4.46939 8.52 4.55714L10.3422 6.45525L13.0222 3.66361C13.193 3.48562 13.4759 3.47984 13.6539 3.65072Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIcon);
export default __webpack_public_path__ + "static/media/decreaseIcon.d1535dd3487829c7f3d98b2bf13e4d0e.svg";
export { ForwardRef as ReactComponent };